export const ShopNavOverlay = (function () {
	'use strict';

    let $shopNavSection;

	function init() {
        $shopNavSection = $('.shop-navbar-up');
        if($shopNavSection.length > 0) {
            shopNavOverlay();
        }

        if (document.getElementById('shop-navbar__nav')) {
            legacyNavOverlay();
        }
	}

	function legacyNavOverlay() {
        var shopNav = document.getElementById('shop-navbar__nav');
        var shopNavButton = document.getElementById('shop-navbar__button');
        var navOverlay = document.querySelector('.shop-navbar__overlay');

        shopNavButton.addEventListener('click', function () {
            shopNav.classList.toggle('show');
            navOverlay.classList.toggle('show');
        });

        shopNav.addEventListener('mouseenter', function () {
            this.classList.toggle('show');
            navOverlay.classList.toggle('show');
            shopNavButton.classList.toggle('nav-active');
        });

        shopNav.addEventListener('mouseleave', function () {
            this.classList.toggle('show');
            navOverlay.classList.toggle('show');
            shopNavButton.classList.toggle('nav-active');
        });

        shopNavButton.addEventListener('mouseenter', function () {
            if (!shopNav.classList.contains('show')) {
                shopNavButton.click();
            }
        });

        shopNavButton.addEventListener('mouseleave', function () {
            if (shopNav.classList.contains('show')) {
                shopNavButton.click();
            }
        }); 
    }

    function shopNavOverlay() {
  
        let $shopNav = $shopNavSection.find('.shop-navbar-up__nav');
        let $shopNavButton = $shopNavSection.find('.shop-navbar-up__button');
        $shopNavSection.find('.shop-navbar-up__nav');
        $shopNavButton.on('click', function () {
          if ($shopNavSection.hasClass('active')) {
            $shopNavSection.removeClass('active');
            $shopNav.removeClass('show');
            $('.shop-landing-cta').removeClass('active');
            return;
          }
  
          $shopNavSection.addClass('active');
          $shopNav.addClass('show');
          $('.shop-landing-cta').addClass('active');
        });
      }

	return {
		init: init,
	};
})();
